require('../locales/en');
require('../locales/es');